




















































































import {Component, Prop, Vue} from 'vue-property-decorator'
import axios from 'axios';
import {jobDescriptionOptions} from "@/util/jobDescriptionOptions";

@Component
    export default class RegisterForm extends Vue {

        @Prop({default: ''})
        companyCode!: string

        private error: string | null = null;
        private errors: any = {};
        private firstName: string = '';
        private lastName: string = '';
        private email: string = '';
        private password: string = '';
        private city: string = '';
        private termsAgreement: boolean = false;
        private hasCompanyCode: boolean = this.companyCode !== '';
        private jobDescription: string = '';
        private jobOptions = jobDescriptionOptions;

        private loading: boolean = false;

        private clear() {
            this.errors = {};
            this.loading = false;
        }

        private async submit() {
            if (this.loading) {
                return
            }

            this.clear();
            this.loading = true;

            const formData = new FormData(document.getElementById('sign-up-form') as any);

            axios.post('/register', formData)
                .then(result => {
                    const data = result.data;
                    window.location = data.redirect_url || "/choose-subscription-plan";
                }).catch(error => {
                this.loading = false;
                this.clear();
                this.error = error.response?.data.message || 'Something went wrong'
                this.errors = error.response?.data.errors || {}
            })
        }
    }
